import React from 'react';
import PropTypes from 'prop-types';
import styles from './moreFilters.scss';

const CheckboxFilterSection = ({ title, filterKey, options, backgroundClass, localFilters, handleCheckboxChange }) => {
    if (!Array.isArray(options) || options.length === 0) {
        return null;
    }

    return (
        <div className={`${styles.filterSection} ${backgroundClass}`}>
            <p className={styles.sectionTitle}>{title}</p>
            <div className={styles.checkboxGroup}>
                {options
                    .filter(option => option && typeof option === 'object' && option.value && option.label)
                    .map(option => (
                        <label key={option.value} className={styles.checkboxLabel}>
                            <input
                                type="checkbox"
                                checked={!!localFilters?.[filterKey]?.[option.value]}
                                onChange={() => handleCheckboxChange(filterKey, option.value)}
                                className={styles.checkbox}
                            />
                            <span className={styles.checkboxText}>{option.label}</span>
                        </label>
                    ))}
            </div>
        </div>
    );
};

CheckboxFilterSection.propTypes = {
    title: PropTypes.string.isRequired,
    filterKey: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    backgroundClass: PropTypes.string.isRequired,
    localFilters: PropTypes.instanceOf(Object).isRequired,
    handleCheckboxChange: PropTypes.func.isRequired,
};

export default CheckboxFilterSection;
